//デザインタブ-アイテム/詳細タブ切り替え
import React, { useState } from 'react'
import styled from 'styled-components';
import { ThemeProvider } from '@material-ui/core/styles'
import { Container, Box, Tabs, Tab, Fab } from '@material-ui/core';
import SwapVertIcon from '@material-ui/icons/SwapVert';

import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardAttributeDb, CardAttributeDbHashType } from '../redux/cardAttributeDbSlice';
import { CardShapeDb } from '../redux/cardShapeDbSlice';
import useWindowSize from '@rehooks/window-size'
import { deepCopy } from '../general';
import TabPanel, { TabsAppBar, tabsIndicatorTheme, a11yProps } from '../components/TabPanel'
import SelectItemName from '../components/SelectItemName';
import ItemSetArea from '../components/ItemSetArea';
import { EditTemplateAttributeDbHashType, EditTemplateShapeDbHashType } from '../components/EditTemplateDialog';
import { EditCardShapeDbHashType } from '../components/EditDialog';

type ChangeAttributeOrderFabProps = {
  hover: boolean;
  able?: boolean;
}
const ChangeAttributeOrderFab = styled(Fab)<ChangeAttributeOrderFabProps>`
  position: absolute;
  right: 48px;
  bottom: 88px;
  width: ${props => props.hover ? '292.45px' : '48px'};
  overflow: hidden;
  white-space: nowrap;
  transform: ${props => props.able ? 'scale(1)' : 'scale(0)'};
  transition: ${props => props.hover ? 'width 280ms ease-in' : '200ms'};
`

const isTemplateAttribute = (obj: any): obj is CardTemplateAttributeDb => {
  return typeof obj?.cardAttributeModel === 'string';
}
const isAttribute = (obj: any): obj is CardTemplateAttributeDb | CardAttributeDb => {
  return typeof obj?.cardAttributeModel === 'string';
}
const isShape = (obj: any): obj is CardTemplateShapeDb | CardShapeDb => {
  return typeof obj?.kind === 'string';
}

type ItemDesignAreaItemsType = {
  attributes: EditTemplateAttributeDbHashType;
  setAttributes: (items: EditTemplateAttributeDbHashType) => void;
  shapes: EditTemplateShapeDbHashType;
  setShapes: (shapes: EditTemplateShapeDbHashType) => void;
  changeItem: (item: CardTemplateAttributeDb | CardTemplateShapeDb | null) => void;
} | {
  attributes: CardAttributeDbHashType;
  setAttributes: (items: CardAttributeDbHashType) => void;
  shapes: EditCardShapeDbHashType;
  setShapes: (shapes: EditCardShapeDbHashType) => void;
  changeItem: (item: CardAttributeDb | CardShapeDb | null) => void;
}

const isTemplateAttributes = (obj: any): obj is EditTemplateAttributeDbHashType => {
  const item = obj[Object.keys(obj).filter(id => obj[id])[0]];
  return typeof item?.cardTemplateId === 'string' || !item;
}
const isTemplateSetAttributes = (obj: any): obj is (items: EditTemplateAttributeDbHashType) => void => {
  return true;
}
const isTemplateShapes = (obj: any): obj is EditTemplateShapeDbHashType => {
  const item = obj[Object.keys(obj).filter(id => obj[id])[0]];
  return typeof item?.cardTemplateId === 'string' || !item;
}
const isTemplateSetShapes = (obj: any): obj is (shapes: EditTemplateShapeDbHashType) => void => {
  return true;
}
const isCardAttributes = (obj: any): obj is CardAttributeDbHashType => {
  const item = obj[Object.keys(obj).filter(id => obj[id])[0]];
  return typeof item?.cardId === 'string';
}
const isCardSetAttributes = (obj: any): obj is (items: CardAttributeDbHashType) => void => {
  return true;
}
const isCardShapes = (obj: any): obj is EditCardShapeDbHashType => {
  const item = obj[Object.keys(obj).filter(id => obj[id])[0]];
  return typeof item?.cardId === 'string' || !item;
}
const isCardSetShapes = (obj: any): obj is (shapes: EditCardShapeDbHashType) => void => {
  return true;
}

type ItemDesignAreaProps = {
  ids: string[];
  allItems: ItemDesignAreaItemsType;
  selectingId: string | undefined;
  setSelectingId: (id: string | undefined) => void;
  onChangeAttributeOrder?: () => void;
  tabValue: number;
  setTabValue: (tabValue: number) => void;
}
const ItemDesignArea: React.FC<ItemDesignAreaProps> = ({ids, allItems, selectingId, setSelectingId, onChangeAttributeOrder, tabValue, setTabValue}) => {
  const {attributes, setAttributes, shapes, setShapes, changeItem} = allItems;
  const existingAttributeIds = Object.keys(attributes).filter(id => attributes[id]);
  const selectingAttribute = typeof selectingId === 'string' ? attributes[selectingId] : null;
  const selectingShape = typeof selectingId === 'string' ? shapes[selectingId] : null;
  const windowSize = useWindowSize()
  const workHeight = windowSize.innerHeight - (64 * 2) - 180
  const [fabHover, setFabHover] = useState(false);

  const handleChange = (ev: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue)
  }
  const setAllItems = (newAttributes: EditTemplateAttributeDbHashType | CardAttributeDbHashType, newShapes: EditTemplateShapeDbHashType | EditCardShapeDbHashType) => {
    if (isTemplateSetAttributes(setAttributes) && isTemplateAttributes(newAttributes) && isTemplateSetShapes(setShapes) && isTemplateShapes(newShapes)) {
      setAttributes(newAttributes);
      setShapes(newShapes);
    }
    else if (isCardSetAttributes(setAttributes) && isCardAttributes(newAttributes) && isCardSetShapes(setShapes) && isCardShapes(newShapes)) {
      setAttributes(newAttributes);
      setShapes(newShapes);
    }
  }
  const updateItemsProps = (targetZ: number, targetOrder?: number): [EditTemplateAttributeDbHashType, EditTemplateShapeDbHashType] | [CardAttributeDbHashType, EditCardShapeDbHashType] => {
    const newAttributes = deepCopy(attributes);
    const newShapes = deepCopy(shapes);
    ids.forEach(id => {
      const attribute = attributes[id];
      const shape = shapes[id];
      if (attribute) {
        if (typeof targetOrder === 'number' && attribute.order > targetOrder && attribute.z > targetZ) {
          newAttributes[id] = {...attribute, order: attribute.order - 1, z: attribute.z - 1};
        }
        else if (typeof targetOrder === 'number' && attribute.order > targetOrder) newAttributes[id] = {...attribute, order: attribute.order - 1};
        else if (attribute.z > targetZ) newAttributes[id] = {...attribute, z: attribute.z - 1};  
      }
      else if (shape && shape.z > targetZ) newShapes[id] = {...shape, z: shape.z - 1};
    })
    if (isTemplateAttributes(newAttributes) && isTemplateShapes(newShapes)) return [newAttributes, newShapes];
    else return [newAttributes, newShapes] as [CardAttributeDbHashType, EditCardShapeDbHashType];
  }
  const deleteItem = () => {
    const targetZ = selectingAttribute ? selectingAttribute.z : selectingShape?.z;
    const targetOrder = selectingAttribute ? selectingAttribute.order : undefined;
    if (!selectingId || typeof targetZ !== 'number') return;
    const [newAttributes, newShapes] = updateItemsProps(targetZ, targetOrder);
    // delete selecting item
    if (isTemplateAttribute(selectingAttribute)) newAttributes[selectingId] = null;
    else if (selectingShape) newShapes[selectingId] = null;
    setTabValue(0);
    setSelectingId(undefined);
    setAllItems(newAttributes, newShapes)
  }
  const changeItemZ = (dropZ: number) => {
    if (typeof selectingId !== 'string') return;
    const newAttributes = deepCopy(attributes);
    const newShapes = deepCopy(shapes);
    const targetItem = selectingAttribute ? deepCopy(selectingAttribute) : deepCopy(selectingShape);
    if (!targetItem) return;
    // update selecting item's z
    const dragZ = targetItem.z;
    targetItem.z = dropZ;
    if (isAttribute(targetItem)) newAttributes[selectingId] = targetItem;
    else if (isShape(targetItem)) newShapes[selectingId] = targetItem;
    // update other items' z
    if (dragZ < dropZ) {
      ids.forEach(id => {
        const item = attributes[id];
        const shape = shapes[id];
        if (id !== selectingId && item && dragZ < item.z && item.z <= dropZ) {
          newAttributes[id] = {...item, z: item.z - 1};
        } else if (id !== selectingId && shape && dragZ < shape.z && shape.z <= dropZ) {
          newShapes[id] = {...shape, z: shape.z - 1};
        }
      });
      setAllItems(newAttributes, newShapes)
    } else if (dragZ > dropZ) {
      ids.forEach(id => {
        const item = attributes[id];
        const shape = shapes[id];
        if (id !== selectingId && item && dropZ <= item.z && item.z < dragZ) {
          newAttributes[id] = {...item, z: item.z + 1};
        } else if (id !== selectingId && shape && dropZ <= shape.z && shape.z < dragZ) {
          newShapes[id] = {...shape, z: shape.z + 1};
        }
      });
      setAllItems(newAttributes, newShapes)
    }
  }

  return (
    <Box>
      <ThemeProvider theme={tabsIndicatorTheme}>
        <TabsAppBar position="static" elevation={0}>
          <Tabs value={tabValue} onChange={handleChange} variant="fullWidth">
            <Tab label="アイテム" {...a11yProps(0)} />
            <Tab label="詳細設定" {...a11yProps(1)} />
          </Tabs>
        </TabsAppBar>
        <TabPanel value={tabValue} index={0}>
          <Container style={{height: workHeight, overflow: 'auto'}}>
            { ids.length > 0 &&
              <SelectItemName ids={ids}
                attributes={attributes} shapes={shapes}
                selectingId={selectingId}
                setSelectingId={setSelectingId}
                changeItemZ={changeItemZ}
                openDetailTab={() => setTabValue(1)}
              />
            }
            <ChangeAttributeOrderFab variant="extended" color="primary"
              able={existingAttributeIds.length > 0} hover={fabHover}
              onMouseEnter={() => setFabHover(true)} onMouseLeave={() => setFabHover(false)}
              onClick={onChangeAttributeOrder}>
              <SwapVertIcon />
              <div style={{display: fabHover ? undefined : 'none', marginLeft: '8px'}}>入力画面での並び順を指定する</div>
            </ChangeAttributeOrderFab>
          </Container>
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Container style={{height: workHeight-10, overflow: 'auto'}}>
            { (ids.length > 0) &&
              <ItemSetArea id={selectingId} item={selectingAttribute || selectingShape}
                changeItem={changeItem} deleteItem={deleteItem} />
            }
          </Container>
        </TabPanel>
      </ThemeProvider>
    </Box>
  );
}

export default ItemDesignArea;
